<template>
  <div class="merchants">
    <page-search
      ref="pageSearchRef"
      :searchFormConfig="searchFormConfig"
      :pageTitle="$t('common.app-log-audit')"
      @resetBtnClick="handleResetClick"
      @queryBtnClick="handleQueryClick"
    >
    </page-search>
    <page-content
      style="margin-top: 10px"
      ref="pageContentRef"
      v-bind="tableOptionsConfig"
      @pageInfoChange="pageInfoChangeAction"
    ></page-content>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

import pageSearch from '@/components/PageSearch/page-search'
import pageContent from '@/components/PageContent/page-content.vue'
import { searchFormConfig } from './config/audit.form'
import { contentTableConfig } from './config/audit.table'

// import { useRouter } from 'vue-router'

const tableOptions = {
  moduleName: 'log', // 所属的模块
  pageName: 'audit', // 所属的页面
  contentTableConfig, // 表格列的基础配置
  isShowCreateSlot: false, // 是否显示添加按钮的插槽
  isShowDeleteSlot: true,
  pageAction: 'log/getAuditListData', // 获取表格的Action
  pageCountGetter: 'log/pageListCount', // 获取表格记录数据总和getters
  pageListGetter: 'log/pageListData',
  deleteSelectionAction: 'log/deleteMultiAudit' // 获取表格列表数据getters
}
const tableOptionsConfig = computed(() => tableOptions)

const pageContentRef = ref('')
const pageSearchRef = ref('')

const handleQueryItem = (items) => {
  const array = []
  const obj = {}
  Object.keys(items).forEach((key) => {
    if (items[key] !== '') array.push(key)
  })
  array.forEach((key) => {
    obj[key] = items[key]
  })
  return obj
}
const handleQueryClick = (queryInfo) => {
  // TODO后端规范问题
  const hasQueryInfo = !!Object.values(queryInfo).find((item) => item !== '')
  queryInfo = hasQueryInfo ? handleQueryItem(queryInfo) : {}
  // 调用page-search中的getPageData方法
  pageContentRef.value.getPageData(queryInfo)
}
const handleResetClick = () => {
  pageContentRef.value.getPageData()
}

const pageInfoChangeAction = () => {
  const formData = pageSearchRef.value.getCurrentFieldValues()
  pageContentRef.value.getPageData(formData)
}
</script>
